/** Product line types that should participate in ship-mode shipping quotes. */
export const PHYSICAL_TYPES_FOR_SHIPPING = [
  'physical',
  'print_on_demand',
  'bundle',
  'rental',
];

function norm(s) {
  return typeof s === 'string' ? s.toLowerCase() : '';
}

/**
 * From a shop product record (PDP, collection, list), derive the cart `productType`
 * used for shipping and checkout. Keeps digital / donation distinct from shippable goods.
 */
export function resolveShopProductTypeForCart(product) {
  if (!product) return 'physical';
  const raw = product.productType || product.type;
  const lower = norm(raw);
  if (lower === 'digital') return 'digital';
  if (lower === 'donation') return 'donation';
  if (PHYSICAL_TYPES_FOR_SHIPPING.includes(lower)) return lower;
  if (product.printfulData?.printfulProductId || product.printfulProductId) {
    return 'print_on_demand';
  }
  return 'physical';
}

/**
 * Fills in `productType` when callers only set `type: 'product'` or Printful fields,
 * so shipping quotes and thresholds run for shippable merchandise.
 */
export function ensureCartLineShippingFields(line) {
  if (!line || typeof line !== 'object') return line;
  const next = { ...line };
  const t = norm(next.type);
  const pt = norm(next.productType);

  if (t === 'donation' || pt === 'donation' || t === 'event' || next.eventId) {
    return next;
  }
  if (t === 'digital' || pt === 'digital') {
    if (!next.productType) next.productType = 'digital';
    return next;
  }

  if (pt && PHYSICAL_TYPES_FOR_SHIPPING.includes(pt)) return next;
  if (PHYSICAL_TYPES_FOR_SHIPPING.includes(t)) {
    if (!next.productType) next.productType = t;
    return next;
  }

  if (next.printfulProductId || next.printfulVariantId || next.printful_data) {
    if (!next.productType) next.productType = 'print_on_demand';
    return next;
  }

  if (t === 'product' && next.productId) {
    if (!next.productType) next.productType = 'physical';
    return next;
  }

  return next;
}

/**
 * True when this line should trigger POST quote-shipping / cart shipping UI (ship mode).
 */
export function cartLineNeedsShippingQuote(item) {
  const row = ensureCartLineShippingFields(item);
  const t = norm(row.type);
  const pt = norm(row.productType);
  if (t === 'donation' || pt === 'donation') return false;
  if (t === 'event' || item.eventId) return false;
  if (t === 'digital' || pt === 'digital') return false;
  return (
    PHYSICAL_TYPES_FOR_SHIPPING.includes(t) ||
    PHYSICAL_TYPES_FOR_SHIPPING.includes(pt)
  );
}
